<template>
  <div class="canvas-box" ref="myChart"></div>
</template>

<script>
import { weidu } from "./config";
export default {
  props: ["model"],
  data() {
    return {
      weidu: weidu
    };
  },
  mounted() {
    if (this.model) {
      this.weidu = this.model;
    }
    this.renderMap();
  },
  methods: {
    renderMap() {
      let myChart = this.$echarts.init(this.$refs["myChart"]);
      let waiwei = 100 / this.weidu.length;
      let groups = [];
      let weidus = [];
      let indicators = [];
      let indicatorValues = [];
      this.weidu.map(wd => {
        let exists = groups.filter(g => g.name == wd.group);
        if (exists.length == 0) {
          groups.push({ name: wd.group, value: waiwei });
        } else {
          exists[0].value += waiwei;
        }
      });
      groups.map(gr => {
        let wds = this.weidu.filter(wd => wd.group == gr.name);
        weidus = weidus.concat(
          wds.map(item => {
            return { name: item.name, value: waiwei };
          })
        );
        indicators = indicators.concat(
          wds.map(item => {
            return { name: item.name, max: 5 };
          })
        );
        indicatorValues = indicatorValues.concat(
          wds.map(item => {
            return item.value;
          })
        );
      });

      let startAngle = 360 / this.weidu.length / 2;

      let option = {
        radar: {
          radius: "45%",
          startAngle: 90 + startAngle,
          name: { show: false },
          splitLine: { show: false },
          splitArea: { show: false },
          axisTick: { show: true },
          indicator: indicators
        },
        series: [
          {
            type: "radar",
            radius: ["0%", "45%"],
            lineStyle: {
              color: "#948a54",
              width: 6
            },
            data: [
              {
                value: indicatorValues.reverse(),
                label: { show: true }
              }
            ]
          },
          {
            type: "pie",
            radius: ["70%", "100%"],
            labelLine: {
              show: false
            },
            itemStyle: {
              color: "#10253f",
              borderWidth: 3,
              borderColor: "#fff"
            },
            label: {
              position: "inner",
              fontWeight: "bolder",
              color: "#fff",
              fontSize: 16
            },
            data: groups
          },
          {
            type: "pie",
            radius: ["45%", "69%"],
            labelLine: {
              show: false
            },
            itemStyle: {
              color: "#c6d9f1",
              borderWidth: 3,
              borderColor: "#fff"
            },
            label: {
              position: "inner",
              fontWeight: "bold",
              color: "#333",
              fontSize: 14
            },
            data: weidus
          }
        ]
      };
      myChart.setOption(option);
    }
  }
};
</script>

<style lang="scss" scoped>
.canvas-box {
  width: 500px;
  height: 470px;
  position: relative;
  margin: 0px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/dataView/echarts/dimension.vue